import { Link, useParams } from "react-router-dom";

import { useMenuDetail } from "@/api/menus";
import { FreshTile } from "@/components/FreshTile";
import { useT } from "@/lib/i18n";

/**
 * Fresh-themed menu detail: a grid of categories (with photos) for
 * the selected menu. Clicking a category navigates to the classic
 * CategoryDetail page which owns the buy form.
 */
export function MenuDetailFresh() {
  const { id } = useParams<{ id: string }>();
  const menuId = id ? Number(id) : null;
  const q = useMenuDetail(menuId);
  const t = useT();

  if (q.isLoading) {
    return (
      <div style={{ fontSize: 13, color: "var(--color-text-muted)" }}>
        {t("common.loading")}
      </div>
    );
  }
  if (q.isError || !q.data) {
    return (
      <div>
        <Link to="/explore" className="fresh-back-link">{t("menu.back")}</Link>
        <div style={{ fontSize: 13, color: "var(--color-text-muted)" }}>
          {t("menu.not_found")}
        </div>
      </div>
    );
  }

  const m = q.data;
  return (
    <div>
      <Link to="/explore" className="fresh-back-link">{t("menu.back")}</Link>

      <h1 style={{
        fontSize: 26,
        fontWeight: 700,
        color: "var(--color-text)",
        letterSpacing: "-0.01em",
      }}>
        {m.name}
      </h1>
      <p style={{ color: "var(--color-text-muted)", marginTop: 4, marginBottom: 20 }}>
        {m.categories.length}{" "}
        {m.categories.length === 1
          ? t("explore.categories.one")
          : t("explore.categories.many")}
      </p>

      {m.categories.length === 0 ? (
        <div style={{ fontSize: 13, color: "var(--color-text-muted)" }}>
          {t("menu.empty")}
        </div>
      ) : (
        <div className="fresh-tile-grid">
          {m.categories.map((c) => (
            <FreshTile
              key={c.category_id}
              to={`/categories/${c.category_id}`}
              title={c.category_name}
              subtitle={`${c.services_count} ${
                c.services_count === 1
                  ? t("explore.services.one")
                  : t("explore.services.many")
              }`}
              imageUrl={c.image_url}
            />
          ))}
        </div>
      )}
    </div>
  );
}
